/**
 * Geteilte Typen + Konstanten fuer die Ticket-Verlaufs-Anzeige.
 *
 * WIRD VERWENDET VON:
 *  - apps/frontend/src/pages/tickets/TicketDetailPage.tsx (interne Sicht)
 *  - apps/frontend/src/portal/pages/CustomerTicketDetailPage.tsx (Kundenportal)
 *
 * Aenderungen am Aktivitaets-Modell hier zentral pflegen.
 */
import { Calendar, Clock, FileText, Image as ImageIcon, Mail, MessageSquare, Wrench, type LucideIcon } from 'lucide-react'

export type ActivityKind =
  | 'comment'
  | 'support'
  | 'appointment'
  | 'service'
  | 'email'
  | 'document'
  | 'image'

export interface ActivityItem {
  id: string
  kind: ActivityKind
  date: string | null // ISO-String
  title: string
  content: string
  author: string | null
  internal: boolean
  /** Wenn gesetzt, ueberschreibt das den Default-Label des Kinds (z. B. "Termin-Vormerkung"). */
  badgeLabel?: string
  /** Schluessel/Wert-Paare fuer den Detail-Modal (Dauer, Ort, Empfaenger, …). */
  meta: Record<string, string>
  /** Originaler TANSS-Eintrag — Caller koennen daraus eigene Edit-Forms befuellen. */
  raw?: Record<string, unknown>
}

interface ActivityKindConfig {
  label: string
  variant: 'info' | 'success' | 'brand' | 'accent' | 'warning' | 'neutral'
  Icon: LucideIcon
}

export const ACTIVITY_LABELS: Record<ActivityKind, ActivityKindConfig> = {
  comment:     { label: 'Kommentar', variant: 'info',    Icon: MessageSquare },
  support:     { label: 'Leistung',  variant: 'success', Icon: Wrench },
  appointment: { label: 'Termin',    variant: 'brand',   Icon: Calendar },
  service:     { label: 'Zeit',      variant: 'success', Icon: Clock },
  email:       { label: 'E-Mail',    variant: 'accent',  Icon: Mail },
  document:    { label: 'Dokument',  variant: 'neutral', Icon: FileText },
  image:       { label: 'Bild',      variant: 'warning', Icon: ImageIcon },
}

/** Reihenfolge der Type-Filter-Chips in der FilterBar. */
export const ACTIVITY_ORDER: ActivityKind[] = [
  'comment',
  'email',
  'support',
  'appointment',
  'service',
  'document',
  'image',
]
